import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import { ScopedCssBaseline } from '@mui/material';
import { SnackbarProvider } from 'src/contexts/era-package/SnackbarContext';
import ABIEntrySummaryTranslationProvider from '../contexts/ABIEntrySummaryTranslationContext';
import { StatementView } from './StatementView';
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap';

// const fullTitle = 'Statement View';
// const shortTitle = 'Statements';
// const BCrumb = [
//   { title: "ABI" },
//   { title: shortTitle, },
// ];

export const StatementPage = () => {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return <CngBasePage
    renderPage={(showSnackbar) => (
      <ABIEntrySummaryTranslationProvider>
        <ScopedCssBaseline>
          <SnackbarProvider>
            <StatementView />
          </SnackbarProvider>
        </ScopedCssBaseline>
      </ABIEntrySummaryTranslationProvider>)}
    extraCngBreadcrumbNameMap={breadcrumbNameMap}
  />
}